import React, { useEffect, useState } from 'react'
import useAxios from 'hooks/useAxios'
import { getAxios } from 'api'
import { toast } from 'libs/toast'
import SingleSignOn from 'components/SingleSignOn'
import * as R from 'ramda'
import useSaveUserActivityLog, { ACTION_NAME } from 'hooks/useSaveUserActivityLog'
import DirectorySyncContainer from 'components/DirectorySync/container'
import useUser from 'hooks/useUser'
import LoginMethod from './LoginMethod'

export const AuthenticationPresentation = () => {
  const saveUserActivityLog = useSaveUserActivityLog()
  const [settings, setSettings] = useState(null)
  const [isPortalLinkLoading, setIsPortalLinkLoading] = useState(false)
  const [hasPortalLinkError, setHasPortalLinkError] = useState(false)

  const userInfo = useUser()
  const companyId = R.path(['selected_workspace', 'id'], userInfo)

  const { fetch: saveSSOSettings } = useAxios({
    url: 'sso/setting/',
    method: 'post',
    skip: true,
  })

  const { data: enabledSSO, loading: checkingSSOFeatureToggle } = useAxios({
    url: 'billing/plans/feature-toggle/',
    method: 'post',
    data: { feature: 'sso' },
  })
  const isEnabledSSO = R.path(['enabled'], enabledSSO)

  const { data: connection, loading: isConnectionLoading } = useAxios({
    url: 'sso/connection/',
    skip: !isEnabledSSO,
  })

  const { data: enabledDirectorySync, loading: checkingDirectoryFeatureToggle } = useAxios({
    url: 'billing/plans/feature-toggle/',
    method: 'post',
    data: { feature: 'directory_sync' },
  })
  const isEnabledDirectorySync = R.path(['enabled'], enabledDirectorySync)

  useEffect(() => {
    if (connection) {
      setSettings({ require_sso: connection.require_sso })
    }
  }, [connection])

  const handleOnClick = () => {
    setIsPortalLinkLoading(true)
    getAxios()
      .get('sso/configuration/')
      .then((res) => {
        setIsPortalLinkLoading(false)
        saveUserActivityLog({
          action: ACTION_NAME.edit_sso_configuration,
          target: `com_${companyId}`,
          statusCode: 200,
          requestBody: userInfo,
        })

        window.open(res.data.link)
      })
      .catch(() => {
        setHasPortalLinkError(true)
        setIsPortalLinkLoading(false)
      })
  }

  function handleSubmit() {
    saveSSOSettings({ data: settings })
      .then((res) => {
        if (res.data) {
          setSettings(res.data)
          toast.success('Settings updated.')
        }
      })
      .catch(() => {
        toast.error('Oops! There was a problem saving SSO settings. Please try again later.')
      })
  }

  if (hasPortalLinkError) {
    toast.error(
      'Oops! There was a problem configuring SSO. Please contact Simplesat support for help.'
    )
  }

  return (
    <div>
      <LoginMethod companyId={companyId} isEnabledSSO={isEnabledSSO} connection={connection} />
      <div className="mt-4">
        <hr />
      </div>

      <SingleSignOn
        connection={connection}
        isConnectionLoading={isConnectionLoading}
        hasPortalLinkError={hasPortalLinkError}
        isPortalLinkLoading={isPortalLinkLoading}
        handleOnClick={handleOnClick}
        settings={settings}
        setSettings={setSettings}
        handleSubmit={handleSubmit}
        isEnabledSSO={isEnabledSSO}
        checkingSSOFeatureToggle={checkingSSOFeatureToggle}
      />
      <div className="mt-4">
        <hr />
      </div>
      <DirectorySyncContainer
        isEnabledDirectorySync={isEnabledDirectorySync}
        checkingDirectoryFeatureToggle={checkingDirectoryFeatureToggle}
      />
      <div className="mt-6" />
    </div>
  )
}
export default AuthenticationPresentation



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/Admin/Authentication/index.js